/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    loginButton: {
        innerHTML: "Connect"
    },
    loginInProgress: "Connecting...",
    loginInput: {
        placeholder: "Login"
    },
    passwordInput: {
        placeholder: "Password"
    }
};